import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailsActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M3.863 4.204h12.273c.753 0 1.364.611 1.364 1.364v8.864c0 .753-.61 1.363-1.363 1.363H3.863c-.752 0-1.363-.61-1.363-1.363V5.568c0-.753.61-1.364 1.363-1.364",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#e6e8fe",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M2.6 5.062 9.01 9.648c.58.415 1.358.415 1.938.002l6.448-4.6"
	})]
});
export default SvgEmailsActive;
